import axios from 'axios';
import { getToken } from './loginVerification';

export const getAllImportant = async () => {
    try {
        const response = await axios.get(`${process.env.REACT_APP_API_HOST}/important/all`);
        return response.data;
    } catch (error) {
        console.error('Error fetching important info:', error);
        return { ok: false, data: [] };
    }
};
